import { gql } from '@apollo/client';
import { UserPermissionFragment } from '../../utils/apollo/permission/fragments';

export default gql`
  query Notification($id: ID!) {
    user(id: $id) {
      ...UserPermissionFields
    }
    notification {
      wsNotifications {
        wsId
        users {
          id
          name
          picture
          email
          lastLogin
        }
        channelNotifications {
          channelId
          badge
        }
        badge
      }
    }
  }
  ${UserPermissionFragment}
`;
